import React, { useEffect, useState, useContext, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Scanner from './components/scanner/Scanner'; 
import Footer from './components/Footer/Footer';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { ProductContext } from './context/ProductContext';


const App: React.FC = () => {
  const [counterVal, setCounterVal] = useState<string | null>(null);
  const { product } = useContext(ProductContext) || {};
  const lambdaCalledRef = useRef(false);

  const getDeviceType = (): string => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(userAgent)) return "Android";
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) return "iOS";
    if (/Macintosh|Windows|Linux/.test(userAgent)) return "Desktop";

    return "Unknown";
  };

  useEffect(() => {
    if (!product || lambdaCalledRef.current) return;
    lambdaCalledRef.current = true;
  
    const hitLambda = async () => {
      const params = new URLSearchParams(window.location.search);
      const rawUid = params.get("uid");
      if (!rawUid) {
        console.warn("No uid parameter found in URL");
        return;
      }
  
      // Try to Base64-decode, otherwise use raw
      let decodedUid = rawUid;
      try {
        decodedUid = window.atob(rawUid);
      } catch {
        
      }
  
      const [productSKU, counter] = decodedUid.split("x");
      if (!productSKU || !counter) {
        console.warn("Invalid uid format. Expected format: <ProductSKU>x<Counter>");
        return;
      }
  
      setCounterVal(counter);
      const scanId = uuidv4();
      const tagId = decodedUid;
  
      // Fetch geolocation
      let geolocation = null;
      try {
        const ipinfoResponse = await axios.get(
          "https://ipinfo.io/json?token=06e90a19377663"
        );
        const ipinfo = ipinfoResponse.data;
        geolocation = {
          country: { S: ipinfo.country },
          loc:     { S: ipinfo.loc },
          city:    { S: ipinfo.city },
          org:     { S: ipinfo.org },
          timezone:{ S: ipinfo.timezone },
          ip:      { S: ipinfo.ip },
          postal:  { S: ipinfo.postal },
          region:  { S: ipinfo.region },
          device:  { S: getDeviceType() },
        };
      } catch (err) {
        console.error("Error fetching geolocation:", err);
      }
  
      const payload = {
        ScanId:        scanId,
        BrandId:       product.brandId,
        ProductSKU:    productSKU,
        TagId:         tagId,
        Counter:       counter,
        Geolocation:   geolocation,
        BrandName:     product.BrandName,
        Timestamp: new Date().toLocaleString(),
        OpenCloseLoop: true,
        ProductDetails:{
          name:        product.productName,
          description: product.productDescription,
        },
      };
  
      try {
        console.log("Posting scan payload:", payload);
        const response = await axios.post(
          "https://se0d8fpgfl.execute-api.ap-south-1.amazonaws.com/default/scan/trace-scan",
          payload,
          { headers: { "Content-Type": "application/json" } }
        );
        console.log("Scan data posted successfully.", {
          sent:          payload,
          responseData:  response.data,
          status:        response.status,
        });
      } catch (err) {
        console.error("Error posting scan data:", err);
      }
    };
  
    hitLambda();
  }, [product]);  

  return (
    <Router>
      {counterVal === "test" && (
        <div>
        <div
          style={{
            width: '100%',
            backgroundColor: '#f0f0f0',
            padding: '10px',
            textAlign: 'center',
            fontFamily: 'Roboto',
          }}
        >
          This is a test product
        </div>
        <div
          style={{
            width: '100%',
            backgroundColor: 'lightBlue',
            padding: '10px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            color: 'green',
          }}
        >
          This product is Genuine
        </div>
        </div>
      )}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/scanner" element={<Scanner />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
